import OpenWorkspace from './OpenWorkspace';

import Route from './route';

export default {
  RenderProp: OpenWorkspace,
  mainRoute: Route,
};
